module.exports = __webpack_public_path__ + "static/media/NafesLogoCropped.371ca078.png";